import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Globe, 
  Phone, 
  Mail, 
  MapPin, 
  Send, 
  Facebook, 
  Twitter, 
  Linkedin, 
  Instagram, 
  Youtube,
  ArrowRight,
  ChevronUp
} from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    console.log('Newsletter signup:', email);
    alert('Thank you for subscribing!');
    setEmail('');
  };

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
    // { name: 'Blog', path: '/blog' },
    // { name: 'Careers', path: '/careers' }
  ];

  const services = [
    'AI & Machine Learning',
    'Medical Coding Services',
    'Custom Software Development',
    'Data Analytics & BI',
    'Healthcare Compliance',
    'Revenue Cycle Management'
  ];

  const resources = [
    { name: 'Case Studies', path: '/case-studies' },
    { name: 'Whitepapers', path: '/whitepapers' },
    { name: 'Documentation', path: '/docs' },
    { name: 'API Reference', path: '/api' },
    { name: 'Support Center', path: '/support' },
    { name: 'FAQs', path: '/faq' }
  ];

  const socialLinks = [
    { icon: <Facebook className="w-5 h-5" />, url: '#', name: 'Facebook' },
    { icon: <Twitter className="w-5 h-5" />, url: '#', name: 'Twitter' },
    { icon: <Linkedin className="w-5 h-5" />, url: '#', name: 'LinkedIn' },
    { icon: <Instagram className="w-5 h-5" />, url: '#', name: 'Instagram' },
    { icon: <Youtube className="w-5 h-5" />, url: '#', name: 'YouTube' }
  ];

  const offices = [
    { city: 'Nandyal', address: ' reliance trenze building\n3 rd floor', phone: '80997 47478' },
    // { city: 'London', address: '45 Innovation Street, EC2A', phone: '+44 20 1234 5678' },
    // { city: 'Singapore', address: '78 Marina Bay, 018956', phone: '+65 6123 4567' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-xl flex items-center justify-center">
                <Globe className="w-7 h-7 text-white" />
              </div>
              <span className="text-3xl font-bold">Saveratech
        Solutions</span>
            </div>
            
            <p className="text-gray-400 leading-relaxed">
              Pioneering  solutions that transform businesses and drive innovation across industries. 
              Join 50+ companies that trust us to deliver cutting-edge technology solutions.
            </p>

            {/* Newsletter Signup */}
            <div className="space-y-3">
              <h4 className="font-semibold text-lg">Subscribe to Our Newsletter</h4>
              <form onSubmit={handleNewsletterSubmit} className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-cyan-500 transition text-white placeholder-gray-500"
                />
                <button
                  type="submit"
                  className="bg-gradient-to-r from-cyan-400 to-blue-500 px-6 py-3 rounded-lg hover:shadow-xl transition transform hover:scale-105 flex items-center gap-2"
                >
                  <Send className="w-5 h-5" />
                </button>
              </form>
            </div>

            {/* Social Links */}
            <div className="space-y-3">
              <h4 className="font-semibold">Follow Us</h4>
              <div className="flex gap-3">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-cyan-400 hover:to-blue-500 transition transform hover:scale-110"
                    aria-label={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-cyan-400 transition flex items-center gap-2 group"
                  >
                    <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-6 text-white">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index} className="text-gray-400 hover:text-cyan-400 transition cursor-pointer">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-bold text-lg mb-6 text-white">Resources</h3>
            <ul className="space-y-3">
              {resources.map((resource, index) => (
                <li key={index}>
                  <Link
                    to={resource.path}
                    className="text-gray-400 hover:text-cyan-400 transition"
                  >
                    {resource.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {offices.map((office, index) => (
            <div key={index} className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-6 hover:border-cyan-500 transition">
              <h4 className="font-bold text-xl mb-4 text-cyan-400">{office.city}</h4>
              <div className="space-y-3 text-gray-400">
                <p className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-1 text-cyan-400" />
                  <span>{office.address}</span>
                </p>
                <p className="flex items-center gap-3">
                  <Phone className="w-5 h-5 flex-shrink-0 text-cyan-400" />
                  <span>{office.phone}</span>
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Certifications & Awards */}


        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-sm text-center md:text-left">
              © 2026 Saveratech
        Solutions. All rights reserved. Empowering businesses through AI innovation.
            </div>
            
            <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-cyan-400 transition">
                Privacy Policy
              </Link>
              <span className="text-gray-700">•</span>
              <Link to="/terms" className="text-gray-400 hover:text-cyan-400 transition">
                Terms of Service
              </Link>
              <span className="text-gray-700">•</span>
              <Link to="/cookies" className="text-gray-400 hover:text-cyan-400 transition">
                Cookie Policy
              </Link>
              <span className="text-gray-700">•</span>
              <Link to="/sitemap" className="text-gray-400 hover:text-cyan-400 transition">
                Sitemap
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-8 right-8 w-14 h-14 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full flex items-center justify-center text-white shadow-2xl hover:shadow-cyan-500/50 transition-all transform hover:scale-110 z-50 group"
        aria-label="Scroll to top"
      >
        <ChevronUp className="w-6 h-6 group-hover:-translate-y-1 transition" />
      </button>
    </footer>
  );
};

export default Footer;